<template>
	<div>
		<modal-confirmacao
			:exibir="exibir"
			:titulo-modal="tituloModalExclusao"
			:subtitulo-modal="subtituloModalExclusao"
			@confirmar="acaoConfirmarExclucaoFiscal"
			@fechar-modal="$emit('fechar-modal')"
		></modal-confirmacao>
	</div>
</template>
<script>
import ModalConfirmacao from '@/views/components/ModalConfirmacao.vue'

export default {
	name: 'modal-excluir-fiscal',
	components: { ModalConfirmacao },
	props: {
		exibir: Boolean,
	},
	emits: ['fechar-modal', 'confirmar-exclusao-fiscal'],
	data() {
		return {
			tituloModalExclusao: 'Excluir',
			subtituloModalExclusao: 'Deseja realmente excluir?',
		}
	},
	methods: {
		acaoConfirmarExclucaoFiscal() {
			this.$emit('confirmar-exclusao-fiscal')
		},
	},
}
</script>
